<article
	class="property-card"
	[class.property-card--interactive]="interactive"
	(click)="onCardClick($event)"
	(keyup)="onCardKeyup($event)"
	[attr.tabindex]="interactive ? 0 : null"
	[attr.role]="interactive ? 'button' : null"
	[attr.aria-label]="computedAriaLabel"
>
	<div class="property-card__layout">
		<div class="property-card__container">
			<div class="property-card__media" *ngIf="imageUrl || showImagePlaceholder">
				<ng-container *ngIf="imageUrl; else placeholder">
					<img [src]="imageUrl" [alt]="imageAlt || address || price || ''" />
				</ng-container>
				<ng-template #placeholder>
					<div class="property-card__placeholder" aria-hidden="true">
						<i [class]="placeholderIcon"></i>
					</div>
				</ng-template>
			</div>

			<div class="property-card__content">
				<header class="property-card__header" *ngIf="price">
					<p class="property-card__price" *ngIf="price">{{ price | currency : 'USD' : 'symbol' : '1.2-2' }}</p>
					<button
						type="button"
						class="property-card__action"
						[disabled]="actionDisabled"
						(click)="onAction($event)"
						[attr.aria-label]="actionAriaLabel"
						*ngIf="showActionIcon"
					>
						<i class="material-icons">auto_awesome</i>
					</button>
				</header>

				<ul class="property-card__metrics" *ngIf="metrics?.length">
					<li *ngFor="let metric of metrics">{{ metric }}</li>
				</ul>
			</div>
		</div>

		<p class="property-card__address" *ngIf="address">
			<i class="fal fa-map" aria-hidden="true"></i>
			<span>{{ address }}</span>
		</p>
	</div>
</article>
